<template>
  <div class="mb-3">
    <v-layout 
      row 
      wrap >
      <v-flex 
        v-if="isAdmin && (!match.blocked || match.blocked === null)"
        xs12>
        <v-text-field
          v-model="commentText" 
          :label="$t(`page.${page}.addComment`)"
          solo
          prepend-icon="comment"
          append-icon="add"
          @click:append="addComment"
        />
      </v-flex>
    </v-layout>
    <v-layout 
      v-if="comments && comments.length>0" 
      row 
      wrap >
      <v-flex 
        v-for="(comment,i) in comments"
        :key="`comment_${i}`"
        xs12
        class="mb-2">
        <v-card color="white" >
          <v-card-text>
            <span v-html="comment.text" />
          </v-card-text>
          <v-layout 
            v-if="comment.by"
            class="text-xs-center caption grey--text pb-1 px-2" >
            <a 
              v-if="isAdmin"
              @click="removeComment(comment)">
              {{ $t('general.delete') }}
            </a>
            <v-spacer/>
            {{ $t('page.match.sendBy',{name: comment.by, when: getDate(comment.when)}) }}
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DateHelper from '@/lib/DateHelper'
import MatchHelper from '@/lib/MatchHelper'
// const debug = require('debug')('OD::MatchComments')

export default {
  name: 'MatchComments',
  components: {},
  props: {
    match: {
      type: Object,
      required: true,
    },
    sport: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      page: 'match',
      commentText: '',
    }
  },
  computed: {
    config() {
      return MatchHelper.config(this.sport)
    },
    comments() {
      if (this.match.comments) {
        const comments = this.match.comments.slice()
        return comments.reverse()
      }
      return null
    },
  },
  watch: {},
  created() {},
  methods: {
    addComment() {
      if (this.commentText) {
        const data = {
          matchId: this.match.id,
          text: this.commentText,
        }
        this.$emit('onAddComment', data)
        this.commentText = ''
      }
    },
    removeComment(comment) {
      if (comment && comment.id) {
        const data = {
          matchId: this.match.id,
          commentId: comment.id,
        }
        this.$emit('onRemoveComment', data)
      }
    },
    getDate(date) {
      return DateHelper.getDateFronNowString(date)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
